import { createReducer } from '../../../reducers/reducerUtil';
import { TOGGLE_SIDEBAR } from './sidebarConstants';

const initialState = {
	toggleStatus: false,
};

const toggleSideBar = (state) => {
	const { toggleStatus } = state;
	//console.log(toggleStatus);
	return { ...state, toggleStatus: !toggleStatus };
};

export default createReducer(initialState, {
	[TOGGLE_SIDEBAR]: toggleSideBar,
});
